module.exports = __webpack_public_path__ + "assets/fonts/GothamPro-BoldItalic.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/gothampro/GothamPro-BoldItalic.eot
// module id = 1893
// module chunks = 0